export const sampleEmailInboxCredentials = [
  {
    email: process.env.INBOX_EMAIL || '',
    password: process.env.INBOX_PASSWORD || '',
  },
];

export const sampleIntegrationsMenu = [
  {
    integration_id: 'whatsapp',
    name: 'WhatsApp',
    description:
      'Integrate Alchemyst with WhatsApp to enhance your communication and customer engagement. This integration allows you to send real-time notifications, automate messages, and provide seamless customer support directly through WhatsApp. Improve responsiveness and streamline your communication channels for a better user experience.',
    enabled: false,
    installed: true,
    icon: '/whatsapp.png',
    tags: ['Communication', 'Customer Support', 'Automation'],
    info: [],
  },
  {
    integration_id: 'twilio',
    name: 'Twilio',
    description:
      'Integrate Alchemyst with Twilio to enhance your communication and customer engagement. ',
    enabled: false,
    installed: true,
    icon: '/twilio.png',
    tags: ['Communication', 'Customer Support', 'Automation'],
    info: [],
  },
  {
    integration_id: 'telegram',
    name: 'Telegram',
    description:
      'Integrate Alchemyst with Telegram to boost your communication and collaboration. With this integration, you can automate message sending, receive real-time updates, and interact with your audience or team effortlessly through Telegram channels and groups. Enhance your workflow and stay connected with minimal effort.',
    enabled: false,
    installed: true,
    icon: '/telegram.png',
    tags: ['Communication', 'Collaboration', 'Automation'],
    info: [],
  },
  {
    integration_id: 'zoho',
    name: 'Zoho',
    description:
      'Integrate Alchemyst with zoho crm for leads ingestion and importing leads',
    enabled: false,
    installed: true,
    icon: '/zoho1.webp',
    tags: ['Communication', 'Collaboration', 'Automation'],
    info: [
      'Create a Zoho CRM Account: If you don’t already have one, sign up for a Zoho CRM account.',
      'Access the API Console: Navigate to the Zoho API Console.',
      'Create a Self Client: This action will generate the necessary credentials for authentication. Make sure to set the scope of the self client as ZohoCRM.modules.ALL.',
      'Obtain Credentials: You will receive a Client ID, Client Secret, and an Authorization Code. These credentials are essential for authenticating your API requests.',
    ],
  },
];
